<template>
  <div id="app">
    <div class="header" v-if="$route.path !== '/chat'">
      <div v-if="$route.path === '/'" style="width: 70px;">
      </div>

      <a 
        href="javascript:void(0)"
        v-if="!($route.path === '/' || $route.path === '/contact') || !($route.query.gim == null)"
        class="go-back"
        @click="goBack()"
      >
        <span class="go-icon">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </span>
        Geri
      </a>

      <div>
      </div>
    </div>
    <div class="header chat-header" v-if="$route.path === '/chat'">
      <div v-if="$route.path === '/'" style="width: 70px;">
      </div>

      <a
        href="javascript:void(0)"
        v-if="($route.path !== '/' && !($route.query.gim == null))"
        class="go-back"
        @click="goBack()"
      >
        <span class="go-icon">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </span>
        Geri
      </a>

      <div>
      </div>
    </div>
    <transition name="fade">
        <router-view></router-view>
    </transition>
  <div class="footer">
  powered by <a href='https://connexease.com' target="_blank">Connexase</a>
  </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  methods: {
    goBack() {
      if (window.location.pathname === '/option/1') {
        window.location.href = window.location.origin;
      } else if (window.location.href !== 'https://milleni.connexease.com') {
          window.location.href = window.location.origin + '/option/1';
      }

      return false;
    }
  }
};
</script>

<style lang="scss">
  body,
  html {
    margin: 0;
    padding: 0;
    font-family: "Roboto", sans-serif;
    font-weight: 300;
  }

  .go-back {
    font-size: 14px;
    color: #858484;
    text-decoration: none;
    top: 15px;
    left: 5%;
    position: absolute;
  }

  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    background: #fff;
    height: 30px;
    border: 1px solid #f5f5f5;
    font-size: 13px;
    padding: 6px;
    box-sizing: border-box;
    color: #9c9c9c;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;

    span {
      opacity: 0.7;
    }

    a {
      color: #6b6a6a;
      text-decoration: none;
      font-weight: 400;
    }
  }

  #app {
    text-align: center;
    color: #2c3e50;
    height: 100vh;
    width: 100%;
    background: #FFFFFF;
    // box-shadow: 0 10px 30px 0 rgba(0,0,0,0.08);
    border-radius: 4px;
    position: relative;

    .header {
      height: 95px;
      width: 100%;
      background-image: linear-gradient(to bottom,#E6E6E6 0%,#F2F2F2 20%,#fff 100%);
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: space-around;
      align-items: center;

      a {
        border-top: 5px solid rgba(255, 255, 255, 0);
        border-bottom: 20px solid rgba(255, 255, 255, 0);
      }
      a:active {
        background:  rgba(255, 255, 255, 0) !important;
      }

      &.chat-header {
        height: initial;
        padding-bottom: 17px;
        padding-top: 17px;
        justify-content: flex-start;

        .go-back {
          top: 10px;
          left: 10px;
        }
      }

      img {
        max-height: 35px;
        position: absolute;
        margin-top: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?bbdcd6f0